import { create } from 'zustand'

interface SupplierUser {
  uid: string
  email: string | null
  displayName: string | null
  photoURL: string | null
  role: string
  nurseryName?: string
  phone?: string
  // Pickup address — used by admin to book Pidge / Porter pickups from
  // the nursery, by the rider to actually find the place, and shown on
  // the printed packing slip. Mirrors the b2b portal's address shape so
  // the data model stays consistent across user types.
  building?:  string
  locality?:  string
  city?:      string
  stateName?: string
  pinCode?:   string
  gstNumber?: string
  panNumber?: string            // income-tax PAN — kept for records; important for GST-unregistered suppliers
  // GST-unregistered self-declaration (recorded on /agreements) — confirms the
  // supplier isn't GST-registered and will flag if they register / cross the threshold.
  gstUnregisteredDeclaredAt?:        { seconds: number }
  gstUnregisteredDeclarationVersion?: string
  // GST registered/billing address (as on the GST certificate) — shown on tax
  // invoices & payouts. The IGST-vs-CGST/SGST split is derived from gstNumber's
  // state code, not these fields (see lib/gst.ts).
  billingAddress?: string
  billingCity?:    string
  billingState?:   string
  billingPin?:     string
  bankAccount?: string
  ifscCode?: string
  supplierId?: string            // links to plants.supplierId
  pushOptOut?: boolean           // true = supplier muted push (we still keep token clean)
  emailNotifications?: boolean   // defaults to true when unset
  // Master wet-ink agreement uploaded by admin after stamp-paper signing.
  // Surfaced read-only on /agreements; supplier never writes this field.
  agreement?: {
    url:         string
    version:     string
    signedAt?:   { seconds: number }
    uploadedAt?: { seconds: number }
    uploadedBy?: string
  }
}

interface Store {
  user:       SupplierUser | null
  isLoading:  boolean
  setUser:    (u: SupplierUser | null) => void
  setLoading: (v: boolean) => void
}

const useStore = create<Store>()(set => ({
  user:       null,
  isLoading:  true,
  setUser:    user      => set({ user }),
  setLoading: isLoading => set({ isLoading }),
}))

export default useStore
